import React, { useState, useEffect } from "react";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import DatePicker from "react-datepicker";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { ToastContainer, toast } from "react-toastify";
import AddRequirement from "./newRequirement/addRequirement.jsx";
import RequirementHistory from "./newRequirement/requirementHistory.jsx";
import { backendApi } from "../../api/apiService.js";
import { useSelector } from "../../components/hooks/hooks.js";

const Newrequirement = () => {
  const { userDetails, userData } = useSelector((state) => state.login);
  const [tabIndex, setTabIndex] = useState(0);
  const [menuClick, setMenuClick] = useState(false);
  const [updateData, setUpdateData] = useState("default");
  const [recruitersList, setRecruitersList] = useState([]);
  const [managersList, setManagersList] = useState([]);
  const toggleMenu = () => {
    setMenuClick(!menuClick);
  };
  const closeMenu = () => {
    setMenuClick(false);
  };

  const getUserList = () => {
    const api = {
      functionName: "userListing",
      site_id: userDetails[0].site_id,
    };
    backendApi(api).then((response) => {
      if (response.success === "1") {
        const recruiters = response.dataSet
          .filter((obj) => obj.roleId === 1 || obj.roleId === 5)
          .map((m) => ({
            ...m,
            label: `${m.first_name} ${m.last_name}`,
            value: m.id,
          }));
        const managers = response.dataSet.map((m) => ({
          ...m,
          label: `${m.first_name} ${m.last_name}`,
          value: m.id,
        }));
        setRecruitersList(recruiters);
        setManagersList(managers);
      }
    });
  };

  useEffect(() => {
    getUserList();
  }, []);

  useEffect(() => {
    if (updateData !== "default") {
      console.log("🚀 ~ Newrequirement ~ updateData:", updateData);
    }
  }, [updateData]);
  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <ToastContainer
          enableMultiContainer
          containerId={"D"}
          position="bottom-right"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header
            Header="New Requirement"
            toggleMenu={toggleMenu}
            menuClick={menuClick}
          />
          <div className="main-container">
            <div className="card main-card">
              <div className="card-body">
                <Tabs
                  selectedIndex={tabIndex}
                  onSelect={(index) => {
                    setTabIndex(index);
                    console.log("🚀 ~ Newrequirement ~ index:", index);
                  }}
                >
                  <TabList>
                    <Tab>New Requirement</Tab>
                    <Tab>History</Tab>
                  </TabList>
                  <TabPanel>
                    <AddRequirement
                      key={(recruitersList, managersList)}
                      recruitersListProps={recruitersList}
                      managersListProps={managersList}
                      setTabIndex={setTabIndex}
                      updateData={updateData}
                    />
                  </TabPanel>
                  <TabPanel>
                    <RequirementHistory
                      setTabIndex={setTabIndex}
                      setUpdateData={setUpdateData}
                    />
                  </TabPanel>
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Newrequirement;
